/**
 * Wallpaper presets — KURAL 58: light/dark uyumlu
 * Dark modda derin renkler, light modda yumuşak pastel tonlar.
 * RunAIOSLayout — useEffect [isDark] içinde tema'ya göre uygun varyant uygulanır.
 */
import type { CSSProperties } from 'react'

export type WallpaperId = 'midnight' | 'ocean' | 'forest' | 'slate' | 'cosmos' | 'ember' | 'void'

interface WallpaperVariants {
  dark: CSSProperties
  light: CSSProperties
}

export const WALLPAPER_VARIANTS: Record<WallpaperId, WallpaperVariants> = {
  midnight: {
    dark:  { background: 'linear-gradient(135deg, #0f0c29 0%, #1a1a2e 50%, #16213e 100%)' },
    light: { background: 'linear-gradient(135deg, #e0e7ff 0%, #ddd6fe 50%, #c7d2fe 100%)' },
  },
  ocean: {
    dark:  { background: 'linear-gradient(160deg, #0a1628 0%, #0d2137 40%, #0a3d5c 100%)' },
    light: { background: 'linear-gradient(160deg, #dbeafe 0%, #bae6fd 40%, #a5f3fc 100%)' },
  },
  forest: {
    dark:  { background: 'linear-gradient(160deg, #0a1a0f 0%, #0d2818 40%, #0a3320 100%)' },
    light: { background: 'linear-gradient(160deg, #d1fae5 0%, #bbf7d0 40%, #a7f3d0 100%)' },
  },
  slate: {
    dark:  { background: 'linear-gradient(135deg, #0f1117 0%, #1a1d27 50%, #141720 100%)' },
    light: { background: 'linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 50%, #cbd5e1 100%)' },
  },
  cosmos: {
    dark:  { background: 'linear-gradient(135deg, #0d0221 0%, #1a0533 50%, #0d1b4b 100%)' },
    light: { background: 'linear-gradient(135deg, #f3e8ff 0%, #e9d5ff 50%, #ddd6fe 100%)' },
  },
  ember: {
    dark:  { background: 'linear-gradient(160deg, #1a0a00 0%, #2d1000 40%, #1a0a14 100%)' },
    light: { background: 'linear-gradient(160deg, #fff7ed 0%, #fed7aa 40%, #fecaca 100%)' },
  },
  void: {
    dark:  { background: '#080808' },
    light: { background: '#fafafa' },
  },
}

/**
 * Geriye dönük uyumluluk — eski kod `WALLPAPER_PRESETS[id]` formatında okuyor.
 * Şimdilik dark variant'ı default olarak export ediyor; hero kısmı tema'ya göre seçecek.
 */
export const WALLPAPER_PRESETS: Record<WallpaperId, CSSProperties> = Object.fromEntries(
  (Object.keys(WALLPAPER_VARIANTS) as WallpaperId[]).map(id => [id, WALLPAPER_VARIANTS[id].dark])
) as Record<WallpaperId, CSSProperties>

export function getWallpaper(id: WallpaperId, isDark: boolean): CSSProperties {
  return WALLPAPER_VARIANTS[id]?.[isDark ? 'dark' : 'light'] ?? WALLPAPER_VARIANTS.midnight.dark
}
